import { tips } from '@/scripts/tools/utils';
import dao from '@/scripts/helper/dao';

const downloader = {
  // 检查 本地 cosBrowser 是否开启了
  checkCosBrowserStatus(successcb, errcb) {
    tips.loading(window.lang.t('core.loading'));
    const img = document.createElement('img');
    img.onload = () => {
      tips.closeTips();
      return successcb && successcb();
    };
    img.onerror = () => {
      tips.closeTips();
      return errcb && errcb();
    };
    img.src = `http://127.0.0.1:9171/active?${Date.now().toString(36)}`;
  },
  /**
   * 将下载列表加入任务
   * @param {Bucket, Region, list} params
   */
  addDownloadTask(params) {
    const { Bucket, Region, selectedList } = params;
    // 添加上传任务
    return dao
      .addCosBrowserTask({
        type: 'download',
        detail: {
          bucket: Bucket,
          region: Region,
          list: selectedList.map(t => t.key),
        },
      })
      .then(res => {
        // 打开cosBrowser
        const id = res ? res.id : '';
        if (id) {
          const url = `cosbrowser://download/?id=${id}&_=${new Date().getTime()}`;

          // 模拟a标签的点击事件
          const a = document.createElement('a');
          a.href = url;
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);

          if (a.click) {
            a.click();
          } else if (document.createEvent) {
            const eventObj = document.createEvent('MouseEvents');
            eventObj.initEvent('click', true, true);
            a.dispatchEvent(eventObj);
          }
          document.body.removeChild(a);

          return downloader.checkDownloadTask(id, 1);
        }
        const code = 'reload';
        return Promise.reject(code);
      });
  },
  // 轮询检查下载任务是否出错
  checkDownloadTask(taskId) {
    return new Promise((resolve, reject) => {
      const nextCheck = count => {
        if (count > 8) {
          const code = 'reload';
          reject(code);
          return;
        }
        // 检查上传任务
        dao
          .checkCosBrowserTask({
            type: 'download',
            id: taskId,
          })
          .then(res => {
            if (res && res.visit_times) {
              resolve();
            } else {
              setTimeout(() => {
                nextCheck(++count);
              }, 1000);
            }
          })
          .catch(() => {
            setTimeout(() => {
              nextCheck(++count);
            }, 1000);
          });
      };

      // 2s 后开启轮询任务
      setTimeout(() => {
        nextCheck(1);
      }, 2000);
    });
  },
};

export default downloader;
